import toast from 'react-hot-toast';
import { useCallback, useState } from 'react';
import { Modal, Loader } from '../../../../UiKit';
import { EmptyState } from '../../../commons';
import { InvalidSearchImg } from '../../../../images/images';
import { MultiMedia } from '../../../../UiKit/multimedia/multimedia';
import { lifelineEndPoints } from '../../../../api/end-points';
import { useQueryCall } from '../../../../api/react-client';

const navigationButtonStyles =
  'tw-text-[14px] tw-font-medium tw-bg-[#318616] tw-text-white tw-rounded-[0.6rem] tw-border-none tw-px-10 tw-py-4 tw-min-h-8 tw-leading-none tw-cursor-pointer disabled:tw-cursor-not-allowed disabled:tw-bg-[#cfcfcf] hover:tw-bg-[#23610e] hover:tw-transition-all hover:tw-duration-300 hover:tw-ease-in-out';

export function OrderIssuesImagesV1({ orderId, userId }) {
  const [isVisible, setIsVisible] = useState(false);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!orderId && !userId) return null;

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <p
        className='tw-text-300 tw-font-medium tw-text-base-green tw-cursor-pointer tw-leading-none'
        onClick={() => setIsVisible(true)}
      >
        View Complaint Images
      </p>

      {isVisible && (
        <OrderIssuesImagesModal
          isVisible={isVisible}
          handleClose={handleClose}
          orderId={orderId}
          userId={userId}
        />
      )}
    </>
  );
}

const OrderIssuesImagesModalComp = (props) => {
  const { data, isLoading, offset, setOffset } = props;
  let mediaList =
    data?.media_data?.map((img) => ({
      src: img?.media_url,
      type: img?.media_type,
      upload_method: img?.upload_method || 'Unknown',
    })) || [];

  const backArrorHandler = useCallback(() => {
    if (offset === 0) return toast.error('You are already at the end');
    if (offset < 5) {
      setOffset(0);
    } else {
      setOffset((o) => o - 5);
    }
  }, [offset, setOffset]);

  const nextArrorHandler = useCallback(() => {
    if (data?.has_more) {
      setOffset((o) => o + 5);
    } else {
      toast.error('No more images to show');
    }
  }, [setOffset, data?.has_more]);

  if (data?.media_data?.length === 0) {
    return (
      <EmptyState
        img={InvalidSearchImg}
        heading='Customer has not submitted any images'
      />
    );
  }

  return (
    <>
      <MultiMedia
        images={mediaList}
        mediaStyle={{
          display: 'flex',
          justifyContent: 'center',
        }}
        title='Complaint Images/Videos'
        showUploadMethod={true}
      />

      {/* Navigation buttons */}
      {data?.has_more || offset > 0 ? (
        <div className='tw-flex tw-justify-center tw-items-center tw-gap-4 tw-mt-[2rem]'>
          <button
            onClick={backArrorHandler}
            disabled={isLoading}
            className={navigationButtonStyles}
          >
            Back
          </button>
          <div>
            {offset} - {offset + 5}
          </div>
          <button
            onClick={nextArrorHandler}
            disabled={isLoading}
            className={navigationButtonStyles}
          >
            Next
          </button>
        </div>
      ) : null}
    </>
  );
};

function OrderIssuesImagesModal({ orderId, userId, isVisible, handleClose }) {
  const [offset, setOffset] = useState(0);
  const queryKey = [
    'lifeline_apis',
    'chat_media',
    'get_images',
    orderId,
    userId,
    offset,
  ];
  const getOrderIssueImgsEndPoint = `${lifelineEndPoints?.GET_CHAT_MEDIA}?order_id=${orderId}&customer_id=${userId}&offset=${offset}&type=complaint`;
  const { data, isLoading } = useQueryCall(
    { keepPreviousData: true },
    getOrderIssueImgsEndPoint,
    queryKey,
  );

  return (
    <Modal
      isMaxContent
      padding={0}
      paddingTop={'1rem'}
      type='large'
      height='100%'
      maxHeight='80vh'
      containerStyles={{ margin: '16px 0 20px 0', padding: '0 20px' }}
      isVisible={isVisible}
      titleComponent={
        <span className='tw-text-[1.8rem] tw-font-medium tw-text-zinc-600'>
          View complaint images/videos{' '}
        </span>
      }
      handleClose={handleClose}
      component={
        isLoading ? (
          <Loader />
        ) : (
          <OrderIssuesImagesModalComp
            data={data}
            offset={offset}
            isLoading={isLoading}
            setOffset={setOffset}
          />
        )
      }
    />
  );
}
